export const getActionByName = (actions, name) => actions.find(action => action.name == name);